import {
  USER_RECEIVE,
  LOGOUT_COMPLETE,
  USER_ACCEPT_TERMS_REQUEST_COMPLETE,
  USER_ACCEPT_TERMS_REQUEST_FAILED,
} from '../actions';

import {
  SETTINGS_CHANGE_SUCCESS,
  SETTINGS_CHANGE_FAILED,
  SETTINGS_START_EDITING,
  UPDATE_SUBSCRIPTION_SETTING,
} from '../settings/actions/settings';

import { EMAIL_CHANGE } from '../settings/actions/email';
import { PASSWORD_CHANGE } from '../settings/actions/password';
import {
  DISPLAY_NAME_CHANGE,
  UPDATE_DISPLAY_NAME,
} from '../settings/actions/display-name';

import {
  ALERT_SETTINGS_CHANGE_SUCCESS,
  ALERT_SETTINGS_CHANGE,
} from '../settings/actions/alert-settings';

export default (
  state = {
    isAuthenticated: false,
    me: undefined,
    id: undefined,
    name: undefined,
    settings: undefined,
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      const { infoPageMap } = action.market;

      return {
        ...state,
        infoPageMap,
      };
    }
    case 'SESSION_RECEIVE': {
      return {
        ...state,
        isAuthenticated: !!action.session.loggedIn,
        loading: false,
      };
    }
    case USER_RECEIVE: {
      const subscriptionGroups = action.me.subscriptionSettings.map(group => {
        const mailId =
          (group.channels.mail && Number(group.channels.mail.id)) || null;
        const pushId =
          (group.channels.push && Number(group.channels.push.id)) || null;

        return {
          title: group.title,
          description: group.description,
          mail: mailId,
          push: pushId,
        };
      });

      const subscriptionSettings = {};

      for (const group of action.me.subscriptionSettings) {
        const mailId =
          (group.channels.mail && Number(group.channels.mail.id)) || null;
        if (mailId) {
          subscriptionSettings[mailId] = group.channels.mail.subscribed;
        }

        const pushId =
          (group.channels.push && Number(group.channels.push.id)) || null;
        if (pushId) {
          subscriptionSettings[pushId] = group.channels.push.subscribed;
        }
      }

      return {
        ...state,
        me: { ...action.me, subscriptionGroups, subscriptionSettings },
        isAuthenticated: true,
        loading: false,
      };
    }

    case LOGOUT_COMPLETE: {
      return {
        ...state,
        isAuthenticated: false,
        me: undefined,
      };
    }

    case SETTINGS_START_EDITING: {
      return {
        ...state,
        settings: {
          editing: action.settings,
          errors: undefined,
          saving: false,
        },
      };
    }

    case EMAIL_CHANGE:
    case PASSWORD_CHANGE:
    case DISPLAY_NAME_CHANGE: {
      return {
        ...state,
        settings: {
          ...state.settings,
          saving: true,
        },
      };
    }

    case SETTINGS_CHANGE_SUCCESS: {
      return {
        ...state,
        settings: {
          ...state.settings,
          editing: undefined,
          errors: undefined,
          saving: false,
        },
      };
    }

    case SETTINGS_CHANGE_FAILED: {
      const errors = {
        'registration.username-taken': 'name', // does-not-exist-on-erros.po
        'auth.invalid-credentials': 'password',
        'registration.password-length': 'password', // does-not-exist-on-erros.po
        'registration.invalid-email': 'email', // does-not-exist-on-erros.po
        'registration.email-invalid': 'email', // does-not-exist-on-erros.po
        'registration.email-in-use': 'email',
        'registration.verification-mail-not-sent': 'email',
        'validation.email-invalid': 'email',
        'request.invalid-parameter': 'displayName',
      };

      const error = errors[action.error];

      return {
        ...state,
        settings: {
          ...state.settings,
          saving: false,
          errors: {
            ...state.settings.errors,
            [error]: action.error,
          },
        },
      };
    }

    case ALERT_SETTINGS_CHANGE:
    case ALERT_SETTINGS_CHANGE_SUCCESS: {
      let settings = {};
      if (Array.isArray(action.setting)) {
        settings = action.setting.reduce((acc, curr) => {
          acc[curr.setting] = curr.value;
          return acc;
        }, {});
      } else {
        settings = {
          [action.setting.setting]: action.setting.value,
        };
      }
      return {
        ...state,
        me: {
          ...state.me,
          alertSettings: {
            ...state.me.alertSettings,
            ...settings,
          },
        },
      };
    }

    case UPDATE_DISPLAY_NAME: {
      return {
        ...state,
        me: {
          ...state.me,
          displayName: action.displayName,
        },
      };
    }

    case USER_ACCEPT_TERMS_REQUEST_COMPLETE: {
      return {
        ...state,
        me: {
          ...state.me,
          updatedTerms: [],
        },
      };
    }

    case USER_ACCEPT_TERMS_REQUEST_FAILED: {
      return {
        ...state,
        me: {
          ...state.me,
          acceptPolicyError: true,
        },
      };
    }

    case 'LIKE_REVIEW_SUCCESS': {
      const updatedLikes =
        action.value === 'like'
          ? [action.id, ...state.me.likes.reviews]
          : state.me.likes.reviews.filter(review => review !== action.id);

      return {
        ...state,
        me: {
          ...state.me,
          likes: {
            ...state.me.likes,
            reviews: updatedLikes,
          },
        },
      };
    }

    case 'LIKE_LIST_SUCCESS': {
      const updatedLikes =
        action.value === 'like'
          ? [action.id, ...state.me.likes.lists]
          : state.me.likes.lists.filter(review => review !== action.id);

      return {
        ...state,
        me: {
          ...state.me,
          likes: {
            ...state.me.likes,
            lists: updatedLikes,
          },
        },
      };
    }

    case 'UPDATE_REVIEW_DATA': {
      if (!action.productId) return { ...state };

      const myReview = action.nodes.find(
        review => review.user.id === state.me.id
      );

      const updatedProducts = [
        ...state.me.reviewedProducts.filter(
          reviewedProduct => reviewedProduct.productId !== action.productId
        ),
        myReview
          ? { productId: action.productId, rating: myReview.rating }
          : null,
      ].filter(x => x);

      return {
        ...state,
        me: {
          ...state.me,
          reviewedProducts: updatedProducts,
        },
      };
    }

    case UPDATE_SUBSCRIPTION_SETTING: {
      return {
        ...state,
        me: {
          ...state.me,
          subscriptionSettings: {
            ...state.me.subscriptionSettings,
            [action.id]: action.subscribed,
          },
        },
      };
    }

    default:
  }

  return state;
};
